import React from 'react';

import { Icon } from '@chakra-ui/react';

export const CxAgentIcon = props => (
  <Icon viewBox="0 0 720 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-564 -28)">
      <g>
        <path d="M1194 478C1194 511.138 1167.14 538 1134 538L774 538 654 658 654 178C654 144.863 680.863 118 714 118L1134 118C1167.14 118 1194 144.863 1194 178Z" stroke="currentColor" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" strokeOpacity="1" fill="none" fillRule="nonzero" />
        <path d="M864 328C864 344.569 850.569 358 834 358 817.431 358 804 344.569 804 328 804 311.431 817.431 298 834 298 850.569 298 864 311.431 864 328Z" stroke="currentColor" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" strokeOpacity="1" fill="none" fillRule="nonzero" />
        <path d="M1044 328C1044 344.569 1030.57 358 1014 358 997.431 358 984 344.569 984 328 984 311.431 997.431 298 1014 298 1030.57 298 1044 311.431 1044 328Z" stroke="currentColor" strokeWidth="30" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="4" strokeOpacity="1" fill="none" fillRule="nonzero" />
      </g>
    </g>
  </Icon>
);
